module.exports = __webpack_public_path__ + "c10b56cfd2345fd2872e2756bc081393.mp3";